<div class="thankyouContainer">
  <div class="thanksContent thanksTitle">
    <h1
      appConfigSettingsTitle
      appConfigSettingsBackground
    >
      {{'ThankYouPage.Title' | translate}}
    </h1>
  </div>

  <div *ngIf="isOneInsured; else twoInsuredsBlock">
    <mat-divider></mat-divider>
    <div class="thanksContent">
      <p appConfigSettingsParagraph *ngIf="firstParagraph">
        {{ firstParagraph | translate }}
      </p>
      <h2 appConfigSettingsSecondTitle *ngIf="subTitle">
        {{ subTitle | translate }}
      </h2>
      <p appConfigSettingsParagraph *ngIf="secondParagraph">
        {{ secondParagraph | translate }}
        <br />
        {{ thirdParagraph | translate }}
      </p>
      <p appConfigSettingsParagraph *ngIf="fourthParagraph">
        {{ fourthParagraph | translate }}
      </p>
    </div>
<!--    <div class="thanksContent">-->
<!--      <p appConfigSettingsParagraph *ngIf="downloadPdf">-->
<!--        {{downloadPdf | translate }}-->
<!--        <a-->
<!--          class="openPdfLink"-->
<!--          (click)="openReceiptPDF($event)"-->
<!--        >-->
<!--          {{"ThankYouPage.DownloadPDF.1" | translate }}-->
<!--        </a>-->
<!--        {{"ThankYouPage.DownloadPDF.2" | translate }} {{transactionId}}-->
<!--      </p>-->
<!--    </div>-->
    <mat-divider></mat-divider>
  </div>
  <ng-template #twoInsuredsBlock>
    <div>
      <mat-divider></mat-divider>

      <div class="thanksContent">
        <p appConfigSettingsParagraph>
          {{ "ThankYouPage.Insured2FirstParagraph" | translate }}
        </p>
        <h2 appConfigSettingsSecondTitle>
          {{ "ThankYouPage.Insured2BoldTitle" | translate }}
        </h2>
        <p appConfigSettingsParagraph>
          {{ "ThankYouPage.Insured2SecondParagraph" | translate }}
          <br />
          {{ "ThankYouPage.Insured2ThirdParagraph" | translate }}
        </p>
        <p appConfigSettingsParagraph>
          {{ "ThankYouPage.Insured2FourthParagraph" | translate }}
        </p>
      </div>
<!--      <div class="thanksContent">-->
<!--        <p appConfigSettingsParagraph>-->
<!--          {{"ThankYouPage.DownloadPDF.0" | translate }}-->
<!--          <a-->
<!--            class="openPdfLink"-->
<!--            (click)="openReceiptPDF($event)"-->
<!--          >-->
<!--            {{"ThankYouPage.DownloadPDF.1" | translate }}-->
<!--          </a>-->
<!--          {{"ThankYouPage.DownloadPDF.2" | translate }} {{transactionId}}-->
<!--        </p>-->
<!--      </div>-->
      <mat-divider></mat-divider>
    </div>
  </ng-template>
</div>
